import DialogTitle from "@mui/material/DialogTitle";
import {Box, Button, IconButton, Step, StepLabel, Stepper} from "@mui/material";
import {
    CheckCircleOutlined,
    Close,
    HistoryOutlined, SaveOutlined,
    WebStoriesOutlined
} from "@mui/icons-material";
import Dialog from "@mui/material/Dialog";
import {useTranslation} from "react-i18next";
import React, {useEffect, useState, useMemo, useCallback} from "react";
import DialogContent from "@mui/material/DialogContent";
import useApiSource from "../../../api/useApiSource";
import {currencyFormat, dateFormat} from "../../../common/formatters/format";
import DialogActions from "@mui/material/DialogActions";
import DialogContentComponent from "../../../common/components/Shared/DialogContentComponent";
import Generales from "../../../common/components/Shared/Generales";
import FieldCalendar from "../../../common/components/forms/fields/FieldCalendar";
import {useAuth} from "../../../common/security/AuthProvider";
import useApi from "../../../api/useApi";
import {
    estatusAdminEnOrdenProcesoFacturacion,
    estatusProcesoFacturacion

} from "../../Constantes";
import LogOrdenCompra from "../ordenesCompra/LogOrdenCompra";
import useGridFilter from "../../../common/hooks/useGridFilter";
import OrdenCompraDetalle from "../ordenesCompra/OrdenCompraDetalle";
import ComentariosRechazoFactura from "./ComentariosRechazoFactura";
import useNotification from "../../../common/components/hooks/useNotification";
import AutorizadoresEnCurso from "./AutorizadoresEnCurso";
import {
    getFirstDayOfMonthIsoString,
    getTodayIsoString
} from "../../../common/utility/dateUtility";
import FieldFileInputsGroup from "../../../common/components/forms/fields/FieldFileInputsGroup";

const DetalleFactura = ({editarForma, proceso}) => {
    const {t} = useTranslation()
    const editable = true// isEditable(menuOptions.usuarios);
    const open = editarForma.id != null;
    const notification = useNotification();
    const api = useApi('configuracion/recepciones');
    const apiAutorizacion = useApi('configuracion/flujoFacturacion');
    const [data, setData] = useState({});
    const apiSource = useApiSource();
    const {esProveedor} = useAuth()
    const [logDialogOpen, setLogDialogOpen] = useState(false);
    const [comentariosDialogOpen, setComentariosDialogOpen] = useState(false);
    const [autorizadoresDialogOpen, setAutorizadoresDialogOpen] = useState(false);
    const {addEditGridContext, editForm} = useGridFilter({api});
    // eslint-disable-next-line
    const [_, setCargandoFactura] = useState(false);
    const fechaActual = getTodayIsoString();
    const primerDiaMes = getFirstDayOfMonthIsoString();
    const fileInputsInitialState = useMemo(() => ({ xml: data ? data.rutaXml : undefined, pdf: data? data.rutaPdf : undefined}), [data]);
    const [fileInputs, setFileInputs] = useState(fileInputsInitialState);

    useEffect(() => setFileInputs(fileInputsInitialState), [fileInputsInitialState])
    useEffect(() => {
        if(open){
            load(editarForma.id).then()}
        // eslint-disable-next-line
    }, [editForm.id, open]);

    const load = useCallback(async (id) => {
        if (id === 0 || id == null) {
            return
        }
        const response = await api.get(id);
        response['estados'] = await apiSource.get('estatusProcesoFacturacion');
        setData(response);
    }, [api, apiSource])

    const changeDate = (value, _) => {
        data['fechaRealPago'] = value;
        // no esperamos, operacion de bg
        apiAutorizacion.post('actualizaFechaRealPago', {
            facturaId:  data['facturaId'],
            fechaRealPago: value,
        }, { showLoading: false });
    }

    const changeDateRegistro = (value, _) => {
        data['fechaRegistroFactura'] = value;
    }

    const closeLogModal = () => {
        setLogDialogOpen(false);
    }

    const closeAutorizadoresModal = () => {
        setAutorizadoresDialogOpen(false);
    }

    const closeComentariosModal = () => {
        setComentariosDialogOpen(false);
        load(editarForma.id);
    }

    const onGuardarButtonClicked = useCallback(async () => {
        if (typeof data?.rutaXml === "string" && data?.rutaXml.length > 0) {
            return;
        }
        if (fileInputs.xml)
        {
            const formData = new FormData();
            formData.append('factura', fileInputs.xml);
            if (fileInputs.pdf)
                formData.append('facturaPdf', fileInputs.pdf);
            setCargandoFactura(true);
            try {
                await api.post(`${editarForma.id}/factura`, formData);
                await load(editarForma.id);
            }catch (e){
                notification.error('Error de validación en archivo XML')
            }
            setCargandoFactura(false);
        }
    }, [data, fileInputs, api, editarForma.id, load, notification]);

    const rechazaOAutoriza = async (esAutorizacion, comentarios) => {

        let accion = (esAutorizacion) ? t('autorizar') : t('rechazar');
        let mensaje = t('¿Está seguro que desea ') + accion;


        if (!esAutorizacion ||  (esAutorizacion && await notification.confirm(mensaje))) {
            const FacturaId = data['facturaId'];
            const fechaRealPago = esAutorizacion ? data['fechaRealPago'] : new Date().toJSON();
            if (esAutorizacion && isNaN(Date.parse(data['fechaRealPago']))) {
                notification.warning(t('Seleccione una fecha correcta'));
                return;
            }
            const fechaRegistroFactura = data['fechaRegistroFactura'];

            setTimeout(async () => {
                await apiAutorizacion.post('apruebaRechazaFlujo', {
                    FacturaId,
                    esAutorizacion,
                    comentarios,
                    fechaRealPago,
                    fechaRegistroFactura
                }, {showLoading: true});

                await load(editarForma.id);
            },500)
        }
    }

    const onFieldInputChanged = (file, field) =>
        setFileInputs(inputs => ({...inputs, [field]: file}));

    const fileInputsGroupFields = useMemo(() => ([
        {
            field: "xml",
            label: "Archivo XML",
            allowedFileExtensions: [".xml"],
            defaultValue: fileInputs?.xml,
            iconOnly: true,
            onChange: onFieldInputChanged,
        },
        {
            field: "pdf",
            label: "Archivo PDF",
            allowedFileExtensions: [".pdf"],
            defaultValue: fileInputs?.pdf,
            iconOnly: true,
            onChange: onFieldInputChanged,
        },
    ]), [fileInputs])

    return(
        <>
            <Dialog
                open={open}
                fullWidth={true}
                maxWidth={'md'}>
                <DialogTitle marginInline={4} marginTop={2} fontWeight={'bold'}>
                    <Box sx={{display: "grid", gridAutoColumns: "1fr", width: "100%", gap: "10px"}}>
                        <Box sx={{gridRow: "1", gridColumn: "1/9"}}>
                            {esProveedor ? t(`Detalle de Factura`) : t(`Autorización`)}
                        </Box>
                        {esProveedor && (<Button size={'small'}  variant="outlined" color={'info'} onClick={() => addEditGridContext.onEdit(data?.ordenCompraId)}>
                            {t('DETALLE ')}{data?.folioOrdenCompra}
                        </Button>)}
                    </Box>
                    <IconButton sx={{position: 'absolute', right: 8, top: 8}} onClick={editarForma.onCancel}>
                        <Close/>
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{marginInline: 4}}>
                    <Box sx={{width: "100%"}} marginBottom={3}>
                        {!esProveedor &&
                            <Stepper activeStep={data?.estatusId >= 0 ? estatusAdminEnOrdenProcesoFacturacion[data?.estatusId] : data?.estatusId} alternativeLabel>
                                {data?.estados?.sort((a, b) => a.id - b.id).map((label) => (
                                    <Step key={label.name}>
                                        <StepLabel>{label.name}</StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        }
                    </Box>
                    <DialogContentComponent>
                        {esProveedor ?
                            <>
                                <Generales>

                                    <Box display={'grid'} sx={{gridTemplateColumns: "2fr 2fr 2fr", marginBottom:'10px'}}>
                                        <label className={'title'}>{t('EMPRESA')}</label>
                                        <label className={'title'}>{t('DÍAS DE CRÉDITO')}</label>
                                        <label style={{ marginRight: '5px' }} className="title">
                                            {t('XML / PDF')}
                                        </label>

                                        <label className={'label'}>{data?.folioFactura}</label>
                                        <label className={'label'}>{data?.diasCredito}</label>

                                        <Box flex={1} >
                                            <FieldFileInputsGroup
                                                mode="horizontal"
                                                fields={fileInputsGroupFields}
                                                readOnly={typeof data?.rutaXml === "string" && data?.rutaXml.length > 0}
                                                actionComponent={
                                                    <Button
                                                        variant="outlined"
                                                        color="info"
                                                        component="button"
                                                        startIcon={<SaveOutlined />}
                                                        onClick={onGuardarButtonClicked}
                                                    >
                                                        Guardar Archivos
                                                    </Button>
                                                }
                                            />
                                        </Box>
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'row-reverse', fontWeight: 'bold', fontSize:'larger', paddingBlock:'20px', color:'primary.main'}}>
                                        {t('Monto Total a Pagar  ')}{currencyFormat(data?.monto)}
                                    </Box>

                                </Generales>
                            </>
                            :
                            <>
                                <Generales>
                                    <Box display={'grid'} sx={{gap: '5px'}}>
                                        <Box flexShrink={0} display="flex" flexDirection="row" alignItems="flex-start"  gap={1}>
                                            <Box flex={1} >
                                                <label style={{ marginRight: '5px' }} className="title">
                                                    {t('XML / PDF')}
                                                </label>
                                                <FieldFileInputsGroup
                                                    mode="horizontal"
                                                    readOnly={typeof data?.rutaXml === "string" && data?.rutaXml.length > 0}
                                                    fields={[
                                                        {
                                                            field: "xml",
                                                            label: "Archivo XML",
                                                            allowedFileExtensions: [".xml"],
                                                            defaultValue: fileInputs?.xml,
                                                            iconOnly: true,
                                                            onChange: onFieldInputChanged,
                                                        },
                                                        {
                                                            field: "pdf",
                                                            label: "Archivo PDF",
                                                            allowedFileExtensions: [".pdf"],
                                                            defaultValue: fileInputs?.pdf,
                                                            iconOnly: true,
                                                            onChange: onFieldInputChanged,
                                                        },
                                                    ]}
                                                    actionComponent={
                                                        <Button
                                                            variant="outlined"
                                                            color="info"
                                                            component="button"
                                                            startIcon={<SaveOutlined />}
                                                            onClick={onGuardarButtonClicked}
                                                        >
                                                            Guardar Archivos
                                                        </Button>
                                                    }
                                                />
                                            </Box>
                                            <Box flex={1}>
                                                {data?.esFacturaMesAnterior && (<>
                                                        <label className="title">
                                                            {t('FECHA DE REGISTRO')}
                                                        </label>
                                                        <FieldCalendar
                                                            className="compacto"
                                                            value={data?.fechaRegistroFactura}
                                                            field={data?.fechaRegistroFactura}
                                                            minDate={primerDiaMes}
                                                            onChange={changeDateRegistro}
                                                        />
                                                </>)}
                                            </Box>
                                            <Box flex={1} display="flex" flexDirection="column" justifyContent="center" textAlign="right">
                                                <label className="title">
                                                    {t('ORDEN DE COMPRA')}
                                                </label>
                                                <Button
                                                    size="small"
                                                    variant="outlined"
                                                    color="info"
                                                    onClick={() => addEditGridContext.onEdit(data?.ordenCompraId)}
                                                >
                                                    {t('DETALLE ')}{data?.folioOrdenCompra}
                                                </Button>
                                            </Box>
                                        </Box>
                                        <Box flexShrink={0} display="flex" flexDirection="column" alignItems="flex-start" justifyContent="space-between" gap={1}>
                                            <Box flex={1}>
                                                <label className={'title'}>{t('FACTURA')}<br/></label>
                                                <label className={'label'}>{data?.folioFactura ? data?.folioFactura : <span style={{fontStyle:'italic'}}>Sin Factura</span>}</label>
                                            </Box>
                                            <Box flex={1}>
                                                <label className={'title'}>{t('PROVEEDOR')}<br/></label>
                                                <label className={'label'}>{data?.proveedor}</label>
                                            </Box>
                                            <Box flex={1} >
                                                <label className={'title'}>{t('DÍAS DE CRÉDITO')}<br/></label>
                                                <label className={'label'}>{data?.diasCredito}</label>
                                            </Box>
                                        </Box>
                                        <Box textAlign='right'>
                                            <Box color='primary.main' fontWeight='bold' style={{fontSize:20}}>
                                                {t('Monto: ')}
                                                {currencyFormat(data?.monto)}
                                            </Box>
                                        </Box>
                                        <Box flexShrink={0} display="flex" flexDirection="row" alignItems="center" justifyContent="space-between" gap={1}>
                                            <Box>
                                                <label className={'title'}>{t('FECHA ESTIMADA DE PAGO')}<br/></label>
                                                <label className={'label'}>{data?.fechaEstimadaPago ? dateFormat(data?.fechaEstimadaPago) : <span style={{fontStyle:'italic'}}>Sin Fecha</span>}</label>
                                            </Box>
                                            <Box>
                                                <label className={'title'}>{t('FECHA REAL DE PAGO')}<br/></label>
                                                <FieldCalendar className="compacto"
                                                               value={data?.fechaRealPago}
                                                               field='fechaRealPago'
                                                               minDate={fechaActual}
                                                               onChange={changeDate}
                                                               disabled={!(data?.habilitaFechaRealPago)} />
                                            </Box>
                                        </Box>
                                    </Box>
                                </Generales>
                            </>
                        }

                    </DialogContentComponent>
                    <DialogActions>
                        <Button sx={{color: 'text.primary'}} onClick={() => setLogDialogOpen(true)}>
                            <HistoryOutlined /> <label style={{fontWeight:'bold'}}> LOG </label>
                        </Button>
                        <Box sx={{display: "grid", gridAutoColumns: "1fr", width: "100%", gap: "10px"}}>
                            {esProveedor ?
                                <>
                                    <Box color={'black'} fontWeight={'bold'} sx={{gridRow: "1", gridColumn: "8/9"}} >
                                        <Button  variant="outlined" color={'inherit'} startIcon={<Close/>}
                                                 disabled={!(data.estatusId === estatusProcesoFacturacion.PendienteCargaFactura)}
                                                 onClick={editarForma.onCancel}>
                                            {t('CANCELAR')}
                                        </Button>
                                    </Box>
                                    <Box textAlign={'right'} color={'black'} fontWeight={'bold'}
                                         sx={{gridRow: "1", gridColumn: "9/10"}}>
                                        <Button  variant="outlined" color={'success'} startIcon={<CheckCircleOutlined/>}
                                                 disabled={!(data.estatusId === estatusProcesoFacturacion.PendienteCargaFactura)}
                                                 onClick={onGuardarButtonClicked}
                                        >
                                            {t('GUARDAR')}
                                        </Button>
                                    </Box>
                                </>
                                :
                                <>
                                    <Box textAlign={'right'} color={'black'} fontWeight={'bold'}
                                         sx={{gridRow: "1", gridColumn: "3/8"}}>
                                        <Button  variant="outlined" color={'info'} startIcon={<WebStoriesOutlined/>}  onClick={() => setAutorizadoresDialogOpen(true)}
                                        >
                                            {t('AUTORIZADORES EN CURSO')}
                                        </Button>
                                    </Box>
                                    <Box color={'black'} fontWeight={'bold'} sx={{gridRow: "1", gridColumn: "8/9"}} >
                                        <Button  variant="outlined" color={'error'} startIcon={<Close/>} disabled={(!(data?.esAutorizador && (data?.estatusId === estatusProcesoFacturacion.ProgramacionPago || data?.estatusId === estatusProcesoFacturacion.PorAutorizar)))}
                                                 onClick={() => setComentariosDialogOpen(true)}>
                                            {t('RECHAZAR')}
                                        </Button>
                                    </Box>
                                    <Box textAlign={'right'} color={'black'} fontWeight={'bold'}
                                         sx={{gridRow: "1", gridColumn: "9/10"}}>
                                        <Button  variant="outlined" color={'success'} startIcon={<CheckCircleOutlined/>}
                                                 disabled={(!(data?.esAutorizador &&
                                                     (data?.estatusId === estatusProcesoFacturacion.ProgramacionPago ||
                                                     data?.estatusId === estatusProcesoFacturacion.PorAutorizar)
                                                 ))}
                                                 onClick={() => rechazaOAutoriza(true,'')}>
                                            {t('AUTORIZAR')}
                                        </Button>
                                    </Box>
                                </>
                            }
                        </Box>
                    </DialogActions>
                </DialogContent>

            </Dialog>
            {editForm.id  != null &&
                <OrdenCompraDetalle editForm={editForm} disabled={!editable}/>
            }
            <LogOrdenCompra open={logDialogOpen} id={editarForma.id} procesoId={proceso} onClose={() => closeLogModal()}/>
            <ComentariosRechazoFactura open={comentariosDialogOpen} onClose={() => closeComentariosModal()}  onRechazar={rechazaOAutoriza}/>
            <AutorizadoresEnCurso open={autorizadoresDialogOpen} id={editarForma.id} onClose={() => closeAutorizadoresModal()}/>
        </>
    )
}

export default DetalleFactura;
